export default "__VITE_ASSET__Cx1dfQ3J__"